import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

let blocks = document.querySelectorAll('.quote-box');

if(blocks.length > 0) {
  blocks.forEach(block => {
    const container = block.querySelector('.quote-container');

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: container.querySelector('blockquote'),
        start: 'top bottom-=100',
      },
      ease: 'power2.out'
    });

    tl.from(container, {
      x: -40
    });

     tl.from(container.querySelector('img'), {
      autoAlpha: 0
    });

    tl.from(container.querySelectorAll('blockquote > *'), {
      autoAlpha: 0,
      stagger: 0.3,
    });

  });
}